import React from 'react'
import Image from 'next/image'

import { getImageUrl } from '@lib/simpleFn'
import ChoiceNumberButton from '@components/Button/ChoiceNumberButton'
import WrongAnswerButton from '@components/Button/WrongAnswerButton'
import useViewResultModeStore from 'store/viewResultMode'
import ChoiceText from '@components/Choices/ChoiceText'

export type ChoiceProps = {
  number: number
  text: string
  image: string
  questionId: number
}

export type ChoiceCompProps = {
  questionNumber: number
  choice: ChoiceProps
  afterChoiceStyle?: string
  setChoice: (choice: number) => void
  selectedChoiceNumber?: number
  setWrong: (choice: number) => void
  isWrong?: boolean
  isAnswer?: boolean
}

const Choice = ({
  questionNumber,
  choice: { number, text, image },
  setChoice,
  selectedChoiceNumber,
  setWrong,
  isWrong,
  isAnswer,
}: ChoiceCompProps) => {
  const { viewResultMode } = useViewResultModeStore()
  const [numberClassName, textClassName] = (() => {
    let _numberClassName = ''
    let _textClassName = ''
    if (number === selectedChoiceNumber)
      _numberClassName = 'bg-_4a4a4a border-cbtLayout text-cbtLayout'
    if (viewResultMode && isAnswer) {
      _numberClassName = 'text-primary-text border-bosalpim'
      _textClassName = 'text-primary-text'
    }
    if (isWrong && !viewResultMode) {
      _textClassName = 'line-through'
    }
    return [_numberClassName, _textClassName]
  })()

  const choiceTextProps = {
    setChoice,
    text,
    textClassName,
    number,
  }

  return (
    <div className={'flex w-full items-center leading-relaxed my-[8px]'}>
      <ChoiceNumberButton
        choiceNumber={number}
        questionNumber={questionNumber}
        afterChoiceBorderTextBgStyle={numberClassName}
        onClick={setChoice}
        isInQuestionArea={true}
      />
      {text && <ChoiceText {...choiceTextProps} />}

      {image && (
        <div className={'m-auto'}>
          <Image
            className={'cursor-pointer'}
            alt={`${number}번 보기`}
            src={getImageUrl(image)}
            width="320"
            height="225"
            onClick={() => setChoice(number)}
            unoptimized
          ></Image>
        </div>
      )}
      {!viewResultMode && (
        <WrongAnswerButton
          isWrong={isWrong || false}
          choiceNumber={number}
          toggleWrongChoice={setWrong}
        />
      )}
    </div>
  )
}

export default Choice
